export const africaCountries = 'BF,ET,GH,KE,RW,TZ,TG,UG';
export const vulnerableAfricaCountries = 'BF,ET,RW,TG,TZ,UG';
export const asiaCountries = 'BD,ID,LK,PH,TH';
export const vulnerableAsiaCountries = 'BD';
export const caribbeanCountries = 'DO,GT,HN,HT,MX,NI,SV';
export const vulnerableCaribbeanCountries = 'HT';
export const southAmericaCountries = 'BO,BR,CO,EC,PE';
export const allVulnerableCountrues = 'BF,ET,RW,TG,TZ,UG,BD,HT';

export const filteredCountries = (
  causes?: string | null,
  location?: string | null,
) => {
  if (causes === 'vulnerableExploitation') {
    switch (location) {
      case africaCountries:
        return vulnerableAfricaCountries;
      case asiaCountries:
        return vulnerableAsiaCountries;
      case caribbeanCountries:
        return vulnerableCaribbeanCountries;
      case southAmericaCountries:
        return southAmericaCountries;
      default:
        return allVulnerableCountrues;
    }
  }
  return location;
};
